import { usePaginatedResource, useResourceItem } from './useCrudResource'
import { getAuditLogs, getAuditLog } from '../api/auditLogApi'

export const AUDIT_LOG_QUERY_KEY = 'audit-logs'

/**
 * Hook to fetch paginated audit logs
 */
export const useAuditLogs = (params = {}, enabled = true) => {
  return usePaginatedResource(AUDIT_LOG_QUERY_KEY, getAuditLogs, params, enabled)
}

/**
 * Hook to fetch a single audit log
 */
export const useAuditLog = (id, enabled = true) => {
  return useResourceItem(AUDIT_LOG_QUERY_KEY, getAuditLog, id, enabled)
}
